import { Card, CardContent } from '@mui/material'
import { useEffect } from 'react'
import { FaRegComments } from 'react-icons/fa6'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import IconBack from '../components/IconBack'
import { useAuth } from '../context/AuthContext'

const Mensagem = () => {
  const history = useHistory()
  const { validateAccess } = useAuth()

  useEffect(() => {
    validateAccess()
    const userFormat = {
      ...JSON.parse(localStorage.getItem('@sisarma-socio-notifications')),
      mensagem: '5', //* Change the number when a new message is added (CardsInitial too)
    }
    localStorage.setItem(
      '@sisarma-socio-notifications',
      JSON.stringify(userFormat)
    )

    document.title = 'SisarmaApp | Mensagem'
  }, [validateAccess])

  return (
    <section>
      <Card className="relative">
        <div
          className="absolute top-6 right-5 text-xl cursor-pointer"
          onClick={() => history.push('/')}
        >
          <IconBack />
        </div>
        <div className="p-5">
          <div className="flex items-center gap-1">
            <FaRegComments />
            <h1 className="text-lg font-semibold">Mensagem</h1>
          </div>
        </div>
      </Card>
      <Card className="mt-2">
        <CardContent className="space-y-3">
          <img
            src="/comunicado.jpeg"
            alt="Comunicado"
            className="w-full sm:max-w-lg mx-auto"
          />
        </CardContent>
      </Card>
    </section>
  )
}

export default Mensagem
